/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { FsxOntapVolume } from '../models/FsxOntapVolume';

/**
* Properties of an AWS FSx file system. Present only when `resourceType` is set to `AWS_FSX`. 
*/
export class AwsFsxResource {
  /**
  * The FSx file system ID.
  */
  'fileSystemId': string;
  /**
  * The type of FSx file system.
  */
  'fileSystemType'?: AwsFsxResourceFileSystemTypeEnum;
  /**
  * Deployment type (e.g. SINGLE_AZ_1, MULTI_AZ_1). Determines whether a standby subnet is required for restore. Only Multi-AZ deployments require two subnets (preferred + standby). 
  */
  'deploymentType'?: string;
  /**
  * The storage capacity of the file system in bytes.
  */
  'storageSize'?: number;
  /**
  * The storage type for the file system.
  */
  'storageType'?: AwsFsxResourceStorageTypeEnum;
  /**
  * The lifecycle status of the file system.
  */
  'lifecycleStatus'?: AwsFsxResourceLifecycleStatusEnum;
  /**
  * The ID of the VPC that the file system is in.
  */
  'vpcId'?: string;
  /**
  * The IDs of the subnets that the file system is associated with.
  */
  'subnetIds'?: Array<string>;
  /**
  * The DNS name for the file system.
  */
  'dnsName'?: string;
  /**
  * The Amazon Resource Name (ARN) of the AWS KMS key used to encrypt the file system.
  */
  'kmsKeyId'?: string;
  /**
  * The name of the file system (from the Name tag).
  */
  'name'?: string;
  /**
  * The AWS account ID of the file system owner.
  */
  'ownerId'?: string;
  /**
  * For ONTAP file systems, the list of discoverable volumes.
  */
  'ontapVolumes'?: Array<FsxOntapVolume>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "fileSystemId",
      "baseName": "fileSystemId",
      "type": "string",
      "format": ""
    },
    {
      "name": "fileSystemType",
      "baseName": "fileSystemType",
      "type": "AwsFsxResourceFileSystemTypeEnum",
      "format": ""
    },
    {
      "name": "deploymentType",
      "baseName": "deploymentType",
      "type": "string",
      "format": ""
    },
    {
      "name": "storageSize",
      "baseName": "storageSize",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "storageType",
      "baseName": "storageType",
      "type": "AwsFsxResourceStorageTypeEnum",
      "format": ""
    },
    {
      "name": "lifecycleStatus",
      "baseName": "lifecycleStatus",
      "type": "AwsFsxResourceLifecycleStatusEnum",
      "format": ""
    },
    {
      "name": "vpcId",
      "baseName": "vpcId",
      "type": "string",
      "format": ""
    },
    {
      "name": "subnetIds",
      "baseName": "subnetIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "dnsName",
      "baseName": "dnsName",
      "type": "string",
      "format": ""
    },
    {
      "name": "kmsKeyId",
      "baseName": "kmsKeyId",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "ownerId",
      "baseName": "ownerId",
      "type": "string",
      "format": ""
    },
    {
      "name": "ontapVolumes",
      "baseName": "ontapVolumes",
      "type": "Array<FsxOntapVolume>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsFsxResource.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum AwsFsxResourceFileSystemTypeEnum {
  Windows = 'WINDOWS',
  Lustre = 'LUSTRE',
  Ontap = 'ONTAP',
  Openzfs = 'OPENZFS'
}
export enum AwsFsxResourceStorageTypeEnum {
  Ssd = 'SSD',
  Hdd = 'HDD',
  IntelligentTiering = 'INTELLIGENT_TIERING'
}
export enum AwsFsxResourceLifecycleStatusEnum {
  Available = 'AVAILABLE',
  Creating = 'CREATING',
  Failed = 'FAILED',
  Deleting = 'DELETING',
  Misconfigured = 'MISCONFIGURED',
  Updating = 'UPDATING',
  MisconfiguredUnavailable = 'MISCONFIGURED_UNAVAILABLE'
}

